<template>
  <nav
    class="nav-desktop"
    :class="{ 'nav-desktop--backdrop': openSubdropIndex != null }"
  >
    <div class="nav-desktop__list">
      <NavDesktopLink
        v-for="(link, index) in navigation"
        :key="index"
        :link="link"
        :index="index"
        :open="index === openSubdropIndex"
        :lang="lang"
        @link-click="handleLinkClick"
        @toggle-subdrop="handleSubdropToggle"
      />
    </div>

    <template v-if="buttonNavigation.length || localeNavigation.length > 1">
      <div class="nav-desktop__aside">
        <NavDesktopLocaleSwitcher
          :locale-navigation="localeNavigation"
          :open="isLocaleSwitcherOpen"
          :translation="translation"
          @toggle="handleLocaleSwitcherToogle"
        />

        <ul
          v-if="buttonNavigation.length"
          class="nav-desktop__buttons"
        >
          <li
            v-for="button in buttonNavigation"
            :key="button.content"
          >
            <ButtonBase :button="button" />
          </li>
        </ul>
      </div>
    </template>
  </nav>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { ILocaleNavigation, INavigationWithMedia, ISocialNavigation, UiButtonProps } from '~ui/types'

interface Props {
  navigation: Array<INavigationWithMedia>
  buttonNavigation: Array<UiButtonProps>
  localeNavigation: Array<ILocaleNavigation>
  socialNavigation: Array<ISocialNavigation>
  translation: Record<string, string>
  lang: string
}

defineProps<Props>()

const isLocaleSwitcherOpen = ref<boolean>(false)
const openSubdropIndex = ref<null | number>(null)

const handleLocaleSwitcherToogle = (value: boolean) => {
  isLocaleSwitcherOpen.value = value
}

const handleLinkClick = () => {
  openSubdropIndex.value = null
  isLocaleSwitcherOpen.value = false
}

const handleSubdropToggle = (index: number | undefined) => {
  openSubdropIndex.value = typeof index === 'number' ? index : null
  isLocaleSwitcherOpen.value = false
}
</script>

<style lang="scss">
.nav-desktop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    top: var(--subdrop-offset, 0px);
    inset-inline: 0;
    z-index: z-index(over);
    height: calc(100vh - var(--subdrop-offset, 0px));
    height: calc(100svh - var(--subdrop-offset, 0px));
    background-color: rgba(color(black), 4%);
    backdrop-filter: blur(rem(8px));
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s;
  }

  :where(& ul) {
    margin: 0;
  }

  &--backdrop::before {
    opacity: 1;
  }

  &__aside {
    display: flex;
    height: 100%;
    gap: rem(12px);
    position: relative;
  }

  &__buttons {
    margin: 0;
    padding: 0;
    height: 100%;

    & li {
      height: 100%;
    }

    & .button-base {
      height: 100%;
      margin: 0;

      & > span {
        height: 100%;
      }
    }
  }

  &__list {
    height: 100%;
    display: flex;
    gap: range-clamp(8px, 24px, 1100px, 1400px);

    & *::before {
      bottom: -15px;
    }
  }
}
</style>
